import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RiverDelta2TerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RIVER_DELTA2;
}

export default RiverDelta2TerrainTileEntity;
